
module.exports = function isEmail (string) {
    return (/.+\@.+\..+/).test(string);
};


//////////////////
// WEBPACK FOOTER
// ./~/is-email/index.js
// module id = 204
// module chunks = 0